import React from "react";
import { CrossCheckSheetAPI } from "apis";
import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import TextAreaWithJsonCheck from "components/common/TextAreaWithJsonCheck";
import Checkbox from "components/common/Checkbox";
import { MESSAGE } from "constants/Message";
import { inputClass } from "helpers/StyleClass";
import { ROLE } from "./CrossCheckHelper";

class CreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
      isSaving: false,

      name: "",
      inputConfig: "",
      isOpenOverwrite: false,
    };

    this.handleOpenOverwriteChanged =
      this.handleOpenOverwriteChanged.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleOpenOverwriteChanged(value) {
    const { inputConfig } = this.state;
    if (value === true && inputConfig === "") {
      this.setState({ inputConfig: "{}" });
    }

    this.setState({ isOpenOverwrite: value });
  }

  async handleConfirm() {
    const { name, inputConfig, isOpenOverwrite } = this.state;
    const { networkId, role, sheetId } = this.props;

    if (!name || name === "") {
      this.setState({ msg: ["Name cound not be empty", MESSAGE.ERROR] });
      return;
    }

    this.setState({ isSaving: true, msg: [] });

    try {
      if (role === ROLE.CCS) {
        const overwriteSetting =
          inputConfig !== "" && isOpenOverwrite
            ? JSON.parse(inputConfig)
            : null;
        const params = {
          name,
          networkId,
          ...(overwriteSetting && { overwriteSetting }),
        };
        const { sheet_id } = await CrossCheckSheetAPI.createCrossCheckSheet(
          params
        );
        if (sheet_id) {
          this.setState({
            isSaving: false,
            msg: ["Cross check sheet created successfully", MESSAGE.SUCCESS],
          });
        }
      } else if (role === ROLE.INSTANCE && sheetId) {
        const { instance_id } = await CrossCheckSheetAPI.createCcsInstance({
          name,
          networkId,
          sheetId,
        });
        if (instance_id) {
          this.setState({
            isSaving: false,
            msg: ["Google sheet created successfully", MESSAGE.SUCCESS],
          });
        }
      }
    } catch (err) {
      this.setState({
        isSaving: false,
        msg: [
          `Failed to create ${role.toLowerCase()}. ${err || ""}.`,
          MESSAGE.ERROR,
        ],
      });
    }
  }

  render() {
    const { handleClose, handleCancel, role } = this.props;
    const { msg, isSaving, inputConfig, isOpenOverwrite } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        title={`Create ${role}`}
        showCloseFooter={false}
        customOverlayStyle={{ zIndex: 100 }}
        width="35%"
      >
        <div className="mb-6">
          <div className="text-gray-600">{role} Name</div>
          <input
            type="text"
            className={inputClass}
            placeholder={`Enter ${role.toLowerCase()} name`}
            onChange={(e) => this.setState({ name: e.target.value })}
          ></input>
          {role === ROLE.CCS && (
            <>
              <div className="mb-1 mt-2 flex items-center gap-1 text-gray-600">
                <Checkbox
                  id="open-overwrite-setting"
                  isChecked={isOpenOverwrite}
                  onChange={this.handleOpenOverwriteChanged}
                ></Checkbox>
                <label htmlFor="open-overwrite-setting">
                  Overwrite Setting
                </label>
              </div>
              {isOpenOverwrite && (
                <TextAreaWithJsonCheck
                  rows={8}
                  iconOnly={true}
                  inputValue={inputConfig}
                  handleInputChanged={(value) =>
                    this.setState({ inputConfig: value })
                  }
                ></TextAreaWithJsonCheck>
              )}
            </>
          )}
        </div>

        <ModalFooter
          msg={msg}
          isLoading={isSaving}
          onClose={handleClose}
          onCancel={handleCancel}
          onConfirm={this.handleConfirm}
        ></ModalFooter>
      </ModalWrapper>
    );
  }
}

export default CreateModal;
